module.exports = __webpack_public_path__ + "static/media/down-arrow.ffe0fa7b.svg";